import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation";
import { Button } from "react-bootstrap";
import qs from "qs";
import { Link } from "react-router-dom";
import { Li } from "react-flags-select";
import axios from "axios";
import { constant, set } from "lodash";
import Loader from "../../components/Loader";
import Constants from "../Variables/Constants";
import { toast } from "react-toastify";

const Profile = () => {
  const [userData, setUserData] = useState("");
  const [loading, setLoading] = useState(false);
  const [favProdCount, setFavProdCount] = useState(0);
  const [savedDesignCount, setSavedDesignCount] = useState(0);

  const getAllProducts = () => {
    const payload = {
      is_favourite: "yes",
    };
    try {
      axios
        .get(`${Constants.getUrls.getProductsCount}?${qs.stringify(payload)}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            setFavProdCount(resp.data.count);
          }
        })
        .catch((error) => {
          console.error("Error in stylesChange:", error);
        });
    } catch (error) {
      console.error("Error in getAllProducts:", error);
    }
  };

  const handleGetSavedDesignCount = async () => {
    try {
      const response = await axios.get(
        Constants.getUrls.getAllCustomizedImage,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        if (data && Array.isArray(data)) {
          setSavedDesignCount(data.length);
        } else {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Invalid data format received from the server.");
          setSavedDesignCount(0);
        }
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const fetchUserData = async () => {
    setLoading(true);
    const url = Constants.getUrls.getUserData;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      setUserData(response.data.data);
      setLoading(false);
      return response.data;
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
        setLoading(false);
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getAllProducts();
    fetchUserData();
    handleGetSavedDesignCount();
  }, []);

  return (
    <>
      <Navigation />
      {loading && <Loader />}
      <div className="container">
        <div className="row profilePage my-5 justify-content-center flex-wrap gap-lg-0 gap-4">
          <div className="col-lg-3 col-md-4 col-6">
            <div className="rounded-4 w-100 h-100 d-flex align-items-start justify-content-center">
              {!userData.profile_pic_url && (
                <img loading="lazy" 
                  className="w-100 hc rounded-4 object-fit-contain"
                  src={"/bi.png"}
                  alt=""
                />
              )}

              {userData.profile_pic_url && (
                <img loading="lazy" 
                  className="w-100 hc rounded-4 object-fit-cover"
                  src={`${Constants.imgDomain + userData.profile_pic_url}`}
                />
              )}
            </div>
          </div>

          <div className="col-9">
            <div className="h-100">
              <div className="row ">
                <div className="col-lg-8 col-12">
                  <div className="border threedshadow  position-relative h-100 p-4 rounded-4">
                    <h2 className="fs-30 text-brown fw-semibold">
                      {userData?.name || "User Name"}
                    </h2>
                    <div className="d-flex align-items-center flex-wrap gap-5">
                      <div className="fs-14 d-flex align-items-start flex-column gap-3 mt-3">
                        <p className="text-muted fw-medium d-flex align-items-center gap-2">
                          <img loading="lazy"  width={25} src="emailIcon.png" alt="" />{" "}
                          <span>Email</span>
                        </p>
                        <p className="fw-medium">
                          {userData?.email || "Email"}
                        </p>
                      </div>
                      <div className="fs-14 d-flex align-items-center flex-column gap-3 mt-3">
                        <p className="text-muted fw-medium d-flex align-items-center gap-2">
                          <img loading="lazy"  width={16} src="callIcon.png" alt="" />{" "}
                          <span className="">Phone no.</span>
                        </p>
                        <p className="fw-medium mt-2">
                          {userData?.mobile_no || "____________"}
                        </p>
                      </div>
                    </div>

                    <Link to="/edit">
                      <Button className="mt-4 btn-warning d-flex align-items-center gap-2 text-white fs-14 fw-semibold position-absolute top-5 right-5">
                        <img loading="lazy"  width={18} src="/edit.png" alt="" /> Edit
                      </Button>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4 col-12 my-lg-0 my-4">
                  <div className="d-flex  flex-column fs-18 h-100 gap-4">
                    <Link to="/orders" className="h-50">
                      <div className="w-100 border threedshadow h-100 p-4 rounded-4">
                        <p className="d-flex align-items-center pt-3 text-dark justify-content-center gap-3">
                          <img loading="lazy"  src="/check.png" alt="" /> My Orders
                        </p>
                      </div>
                    </Link>
                    <Link to="/carts" className="h-50">
                      <div className="w-100 border threedshadow  h-100 p-4 rounded-4">
                        <p className="d-flex align-items-center pt-3 text-dark justify-content-center gap-3">
                          <img loading="lazy"  src="/blackCart.png" alt="" /> Cart
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="row mt-4 fs-18">
                {/* <div className=" col-12 my-2 my-lg-0"> */}
                <div className="col-md-6 my-2 my-lg-0">
                  <Link to={"/saved-design"}>
                    <div className="w-100 text-dark d-flex justify-content-between align-items-center border threedshadow py-2 pb-0 px-4 rounded-4">
                      <p className="d-flex align-items-center pt-2 justify-content-center gap-3">
                        <img loading="lazy"  src="/check.png" alt="" /> Saved Designs
                      </p>
                      <p className="fs-30 fw-semibold text-light-gray">
                        {savedDesignCount}
                      </p>
                    </div>
                  </Link>
                </div>{" "}
                <div className="col-md-6 my-2 my-lg-0">
                  <Link to={"/favorite"}>
                    <div className="w-100 d-flex justify-content-between align-items-center border threedshadow py-2 pb-0 px-4 rounded-4">
                      <p className="d-flex align-items-center pt-2 text-dark justify-content-center gap-3">
                        <img loading="lazy"  src="/heart2.png" alt="" /> Favorite Products
                      </p>
                      <p className="fs-30 fw-semibold text-light-gray">
                        {favProdCount}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="row mt-4 fs-18">
                <div className="col-lg-6 col-12 my-2 my-lg-0">
                  <Link to={"/address"}>
                    <div className="w-100 d-flex justify-content-center align-items-center border threedshadow pt-4 rounded-4">
                      <p className="d-flex align-items-center text-dark justify-content-center gap-3">
                        <img loading="lazy"  width={30} src="/world.png" alt="" /> Address
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-6 col-12 my-2 my-lg-0">
                  <Link to={"/settings"}>
                    <div className="w-100 d-flex justify-content-center align-items-center border threedshadow pt-4 rounded-4">
                      <p className="d-flex align-items-center text-dark justify-content-center gap-3">
                        <img loading="lazy"  width={30} src="/setting.png" alt="" /> Setting
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
